import { useNavigation } from '@zet/common/hooks/useNavigation'
import { BottomSheet, Icon, SH1, SH3, Stack, XStack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'

import FeesOutlined from './../../assets/svg/feesOutlined.svg'

const OPTIONS = {
  hidePayout: {
    icon: 'CurrencyNoteMoney',
  },
  editCustomerDetails: {
    icon: 'EditOutlined',
    title: 'Edit Customer Details',
  },
}

type RecommendtionsHeaderOptionsBSProps = {
  isPayoutVisible: boolean
  isVisible: boolean
  customerId: number | string
  onDismiss?: () => void
  handleHidePayout?: (hide: boolean) => void
}

const RecommendtionsHeaderOptionsBS = ({
  isPayoutVisible,
  isVisible,
  onDismiss,
  customerId,
  handleHidePayout,
}: RecommendtionsHeaderOptionsBSProps) => {
  const { navigate } = useNavigation()
  // const

  return (
    <BottomSheet
      visible={isVisible}
      onDismiss={onDismiss}
      {...(!!customerId && {
        sheetName: 'more_options_recommendation_page_app',
      })}
    >
      <Stack>
        {/* HEADER SECTION */}
        <XStack className=" border-grays-40 items-center justify-between border-b px-4 pb-2">
          <XStack>
            <SH1>{i18n.t('brandPage.moreOptionsTitle')}</SH1>
          </XStack>
          <Icon type="Close" onPress={onDismiss} />
        </XStack>
        {/* HEADER SECTION ENDS */}

        <Stack className="space-y-4 px-3 py-4">
          <Pressable
            onPress={() => {
              onDismiss?.()
              handleHidePayout?.(!isPayoutVisible)
            }}
            eventName="click_action"
            eventPayload={{
              item_name: isPayoutVisible ? 'hide_payout' : 'show_payout',
            }}
          >
            <XStack className="items-center">
              {/* <Icon type={OPTIONS?.hidePayout?.icon} /> */}
              <FeesOutlined width={24} height={24} />
              <SH3 className={'ml-4/2'}>
                {isPayoutVisible
                  ? i18n.t('brandPage.moreOptionsItems.payout.hide')
                  : i18n.t('brandPage.moreOptionsItems.payout.show')}
              </SH3>
            </XStack>
          </Pressable>

          {customerId && (
            <Pressable
              onPress={() => {
                onDismiss?.()
                navigate('EditCustomerDetails', {
                  customerId,
                })
              }}
              eventName="click_action"
              eventPayload={{
                item_name: 'edit_customer_details_app',
              }}
            >
              <XStack className="items-center">
                <Icon type={OPTIONS?.editCustomerDetails?.icon} />
                <SH3 className={'ml-4/2'}>
                  {i18n.t('brandPage.moreOptionsItems.editDetails')}
                </SH3>
              </XStack>
            </Pressable>
          )}
        </Stack>
      </Stack>
    </BottomSheet>
  )
}

export default RecommendtionsHeaderOptionsBS
